<template>
  <ul class="footer-links">
    <li class="footer-links__item">
      <a
        href=""
        class="footer-links__link"
      >
        {{ $t('Privacy policy') }}
      </a>
    </li>
    <li class="footer-links__item">
      <a
        href=""
        class="footer-links__link"
      >
        {{ $t('Disclaimer') }}
      </a>
    </li>
    <li class="footer-links__item">
      <a
        href=""
        class="footer-links__link"
      >
        {{ $t('Copyright') }}
      </a>
    </li>
    <li class="footer-links__item">
      <a
        href=""
        class="footer-links__link"
      >
        {{ $t('Terms and conditions') }}
      </a>
    </li>
  </ul>
</template>

<style src="~layers/app/components/Footer/Links.css" />
